import { axiosGet, axiosGetBlob } from "./apiClient";

// REACT_APP_BASE_URL in this project already points to ".../admin"
const BASE_URL = process.env.REACT_APP_BASE_URL + "/sync-audit";

const listRuns = async ({ limit = 20, page = 0, status = null, from = null, to = null, jobName = null } = {}) => {
  const params = { limit, page };
  if (status) params.status = status;
  if (from) params.from = from;
  if (to) params.to = to;
  if (jobName) params.jobName = jobName;
  return axiosGet(`${BASE_URL}/runs`, params);
};

const getRun = async ({ runId }) => axiosGet(`${BASE_URL}/runs/${runId}`);
const listRunBranches = async ({ runId }) => axiosGet(`${BASE_URL}/runs/${runId}/branches`);

const listRunBranchChanges = async ({ runId, branchId, limit = 50, page = 0, changeType = null, search = null } = {}) => {
  const params = { limit, page };
  if (changeType) params.changeType = changeType;
  if (search) params.search = search;
  return axiosGet(`${BASE_URL}/runs/${runId}/branches/${branchId}/changes`, params);
};

const listUnmatchedItems = async ({ limit = 50, page = 0, branchId = null, from = null, to = null, search = null } = {}) => {
  const params = { limit, page };
  if (branchId) params.branchId = branchId;
  if (from) params.from = from;
  if (to) params.to = to;
  if (search) params.search = search;
  return axiosGet(`${BASE_URL}/unmatched-items`, params);
};

// ✅ FIXED: unmatched items export csv using axiosGetBlob (uses adminToken automatically)
const downloadUnmatchedItemsCsv = async ({ branchId = null, from = null, to = null, search = null } = {}) => {
  const params = { format: "csv" };
  if (branchId) params.branchId = branchId;
  if (from) params.from = from;
  if (to) params.to = to;
  if (search) params.search = search;

  // ✅ Get blob response from API (token handled inside apiClient)
  const resp = await axiosGetBlob(`${BASE_URL}/unmatched-items`, null, params);

  // ✅ Create file download
  const ts = new Date().toISOString().slice(0, 19).replace(/[:T]/g, "-");
  const fileName = `unmatched-items_${ts}.csv`;

  const blob = new Blob([resp.data], { type: "text/csv;charset=utf-8" });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);

  return true;
};

const syncAuditApi = {
  listItemSyncBranches: () => axiosGet(`${BASE_URL}/item-records/branches`),
  getItemSyncRecords: ({branchId, refCode, page = 0, limit = 20, from = null, to = null}) =>
    axiosGet(`${BASE_URL}/item-records`, {branchId, refCode, page, limit, ...(from ? {from} : {}), ...(to ? {to} : {})}),
  listRuns,
  getRun,
  listRunBranches,
  listRunBranchChanges,
  listUnmatchedItems,
  downloadUnmatchedItemsCsv
};

export default syncAuditApi;

